import {orderUrls, order} from './order'

export const repairUrls = [
  ...orderUrls
]

export const repair = {
  order
}



// WEBPACK FOOTER //
// ./src/api/gip/repair/index.js